'use client';

import { c as _c } from "react/compiler-runtime";
import { type MouseEvent, useEffect, useId, useState } from 'react';
export type UseStackedDrawerProps = {
  /** When the host drawer is closed, the stacked drawer should close too. */
  forceClosed?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  /** Sparky close (X / overlay / Esc). Used when stacked over another drawer. */
  onCloseAll?: () => void;
};
export function useStackedDrawer(t0) {
  const $ = _c(24);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    forceClosed: t2,
    onOpenChange,
    onCloseAll
  } = t1;
  const forceClosed = t2 === undefined ? false : t2;
  const [isActive, setIsActive] = useState(false);
  const [hasBeenRendered, setHasBeenRendered] = useState(false);
  const headingId = useId();
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setHasBeenRendered(true);
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[4] !== forceClosed || $[5] !== onOpenChange) {
    t5 = () => {
      if (forceClosed) {
        setIsActive(false);
        onOpenChange?.(false);
      }
    };
    t6 = [forceClosed, onOpenChange];
    $[4] = forceClosed;
    $[5] = onOpenChange;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] !== onOpenChange) {
    t7 = () => {
      setIsActive(false);
      onOpenChange?.(false);
    };
    $[8] = onOpenChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const closeTopDrawer = t7;
  let t8;
  if ($[10] !== onOpenChange) {
    t8 = event => {
      event.stopPropagation();
      event.preventDefault();
      setIsActive(true);
      onOpenChange?.(true);
    };
    $[10] = onOpenChange;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleOpen = t8;
  let t9;
  if ($[12] !== closeTopDrawer) {
    t9 = event_0 => {
      event_0.stopPropagation();
      event_0.preventDefault();
      closeTopDrawer();
    };
    $[12] = closeTopDrawer;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleBack = t9;
  let t10;
  if ($[14] !== closeTopDrawer || $[15] !== onCloseAll) {
    t10 = () => {
      closeTopDrawer();
      onCloseAll?.();
    };
    $[14] = closeTopDrawer;
    $[15] = onCloseAll;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const handleClose = t10;
  let t11;
  if ($[17] !== handleBack || $[18] !== handleClose || $[19] !== handleOpen || $[20] !== hasBeenRendered || $[21] !== headingId || $[22] !== isActive) {
    t11 = {
      isActive,
      hasBeenRendered,
      headingId,
      handleOpen,
      handleBack,
      handleClose
    };
    $[17] = handleBack;
    $[18] = handleClose;
    $[19] = handleOpen;
    $[20] = hasBeenRendered;
    $[21] = headingId;
    $[22] = isActive;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}